import { combineReducers } from 'redux';

import FinancialTypes from './types';

const infoMoneyReportTransfers = (actionName: string, initialState: any, request: String, success: String, error: String) => {
  return (state = initialState ? initialState : {}, action: any) => {
    switch (action.type) {
      case request:
        return {
          ...state,
          isFetching: true,
          id: action.id,
        };
      case success:
        return { ...state, isFetching: false };
      case error:
        return {
          ...action.error,
          ...state,
          isFetching: false,
        };
      default:
        return state;
    }
  };
};

export const financialReducer = combineReducers({
  myExtract: FinancialTypes.myExtract.getReducer(),
  myBlockedExtract: FinancialTypes.myBlockedExtract.getReducer(),
  myFutureExtract: FinancialTypes.myFutureExtract.getReducer(),
  extractItems: FinancialTypes.extractItems.getReducer(),
  loadAvailable: FinancialTypes.loadAvailable.getReducer(),
  bankTransfer: FinancialTypes.bankTransfer.getReducer(),
  anticipationTransfer: FinancialTypes.anticipationTransfer.getReducer(),
  listInvoicesAnticipation: FinancialTypes.listInvoicesAnticipation.getReducer(),
  listTransfers: FinancialTypes.listTransfers.getReducer(),
  loadFilterByMonth: FinancialTypes.loadFilterByMonth.getReducer(),
  filterExtract: FinancialTypes.filterExtract.getReducer(),
  infoMoneyReportTransfers: FinancialTypes.infoMoneyReportTransfers.createReducer(infoMoneyReportTransfers),
});
